export const schoolProgramEnrollmentVsDobHeaders = [
    {
        key: "student_id",
        label: "Student ID"
    },
    {
        key:"Name",
        label:"Name",
    },
    {
        key:"dob",
        label:"DOB"

    },
    {
        key:"age",
        label:"Age"
    },
    {
        key:"calculated_grade",
        label: "Grade"
    },
    {
        key: "stream_name",
        label: "Stream"
    },
    {
        key:"stream_grade_min",
        label:" Stream Grade"
    },
    {
        key:"school_name",
        label:"School",
    },
    {
        key:"day",
        label:"Day",
    },
    {
        key:"program_duration",
        label:"Duration",
    }
  ];